import { Component, inject } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { FaqService } from '../../features/faq/faq.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';

@Component({
  selector: 'faq-list-component',
  templateUrl: 'faq-list.component.html',
  styleUrl: 'faq-list.component.scss',
  imports: [
    CdkAccordionModule,
    CommonModule,
    NoDataComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    PermissionDirective,
    ContentLoaderComponent,
  ],
})
export class FaqlistComponent {
  readonly dialog = inject(MatDialog);
  public faqList: any[] = [];
  public languages: any[] = [];
  public langCode: String = '';
  private searchSubject = new Subject<string>();
  noData = false;
  loading = false;
  searchTerm: string = '';

  constructor(
    private router: Router,
    private tagsService: TagsLanguageService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private faqService: FaqService
  ) {}

  ngOnInit() {
    this.getAllFaq(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllFaq(this.langCode, searchTerm);
      });
  }

  newFaq() {
    this.router.navigate(['faq/new']);
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  getAllFaq(lang: any, search = ''): void {
    this.loading = true;
    this.faqService.getAllFaq(lang, search).subscribe({
      next: (res) => {
        this.faqList = res?.data;
        if (this.faqList.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  getTranslationQuestion(faq: any): string {
    if (!faq?.translations?.length) return '';
    const preferred = faq.translations.find((t: any) => t.langId === 1);
    return preferred?.question || faq.translations[0]?.question;
  }

  getTranslationAnswer(faq: any): string {
    if (!faq?.translations?.length) return '';
    const preferred = faq.translations.find((t: any) => t.langId === 1);
    return preferred?.answer || faq.translations[0].answer;
  }

  onLanguageSelect(event: any) {
    this.langCode = event.value;
    this.getAllFaq(this.langCode);
  }

  deleteFaq(id: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.faqService.deleteFaq(id).subscribe({
          next: (res) => {
            this.toastr.success(res?.message);
            this.getAllFaq(this.langCode);
          },
          error: (err) => {
            console.log(err);
          },
        });
      }
    });
  }

  onEditFaq(id: any) {
    this.router.navigate([`faq/edit/${id}`]);
  }
}
